import { Callout } from '@shinetools/lumen-react'
import { Landmark } from 'lucide-react'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import type { UiSourceValue } from '@features/reconciliation/enums'

import { useEmberTransitionTo } from '../../../../hooks/routing/useEmberTransitionTo'
import { useOrganizationViewUrl } from '../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../utils/routing/reactRoute'
import { requestConnectBankAutoOpen } from '../../utils/connectBankModalUiSourceStore'

const messageKeyByVariant = {
  invoice: 'bank_integration.connect_bank_banner.message.invoice',
  purchase: 'bank_integration.connect_bank_banner.message.purchase',
} as const

interface ConnectBankBannerProps {
  uiSource: UiSourceValue
  variant: keyof typeof messageKeyByVariant
  onDismiss: () => void
}

export const ConnectBankBanner = ({ uiSource, variant, onDismiss }: ConnectBankBannerProps): ReactElement | null => {
  const { t } = useTranslation()

  const { transitionTo } = useEmberTransitionTo()
  const { url: bankAccountsUrl } = useOrganizationViewUrl(reactRoute.organization.bank.getBankAccountsRoute())

  const onAction = useCallback(() => {
    if (bankAccountsUrl) {
      requestConnectBankAutoOpen(uiSource)
      transitionTo(bankAccountsUrl)
    }
  }, [bankAccountsUrl, transitionTo, uiSource])

  return (
    <Callout
      headline={t('bank_integration.connect_bank_banner.headline')}
      message={t(messageKeyByVariant[variant])}
      actionLabel={t('connect_bank')}
      showButton
      showDismiss
      onAction={onAction}
      onDismiss={onDismiss}
      leadingIcon={<Landmark />}
      style={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}
    />
  )
}
